import { ref, watch } from 'vue'
import { useStore } from 'vuex'
import { fetchOutboundActions } from '@/api/outboundActionsApi'
import { fetchOnCallActions } from '@/api/onCallActionsApi'
import { unwrapApiList } from '@/utils/graphql'
import { isApiSuccess } from '@/mixins/Extras/ApiResponse'
import { isKnowledgeBaseS3Key } from '@/mixins/Organization/OrganizationStorage.js'
import { listKnowledgeBaseS3Keys } from '@/utils/knowledgeBaseS3.js'

export function useAgentTabCounts(isSessionReady) {
  const store = useStore()

  const blocksCount = ref(0)
  const actionsCount = ref(0)
  const onCallCount = ref(0)
  const knowledgeCount = ref(0)

  async function refreshKnowledgeCount() {
    const org = store.state.organization || {}
    const text = String(org.org_knowledeg_base || '').trim()
    const hasManual = text && !isKnowledgeBaseS3Key(text)

    try {
      const keys = await listKnowledgeBaseS3Keys(org)
      knowledgeCount.value = keys.length + (hasManual ? 1 : 0)
    } catch {
      knowledgeCount.value = hasManual ? 1 : 0
    }
  }

  async function refreshCounts() {
    if (!isSessionReady.value) return

    await refreshKnowledgeCount()
    blocksCount.value = 0

    const { org_id } = store.getters.sessionContext ?? {}
    if (!org_id) return

    try {
      const [actionsRes, onCallRes] = await Promise.all([
        fetchOutboundActions({ org_id }),
        fetchOnCallActions(),
      ])

      const actionRows = isApiSuccess(actionsRes) ? unwrapApiList(actionsRes) : []
      const onCallRows = isApiSuccess(onCallRes) ? unwrapApiList(onCallRes) : []

      actionsCount.value = actionRows.length
      onCallCount.value = onCallRows.length
    } catch {
      actionsCount.value = 0
      onCallCount.value = 0
    }
  }

  watch(isSessionReady, (ready) => {
    if (ready) refreshCounts()
  }, { immediate: true })

  watch(
    () => store.state.organization,
    () => {
      void refreshKnowledgeCount()
    },
    { deep: true },
  )

  return {
    blocksCount,
    actionsCount,
    onCallCount,
    knowledgeCount,
    refreshCounts,
  }
}
